import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  FileExcelOutlined,
  FileImageOutlined,
  FileOutlined,
  FilePdfOutlined,
  FileTextOutlined,
  FileWordOutlined,
  FileZipOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { isImage } from "../constants/utils";
import { Select } from "antd";
import { debounce, isEmpty } from "lodash";

export function typeOf(value) {
  return Object.prototype.toString.call(value).slice(8, -1);
}

//add table pdf

// var rows = [
//     {
//       "col1": status,
//       "col2": `${data1}\n${data2}`,
//       "col3": creator,
//       "col4": date.getUTCDate()
//     },

export const addTablePdf = (doc, columns, rows) => {
  const listRow = rows.map((rowItem) => {
    let rowItemResult = {};
    columns.forEach(({ key }, index) => {
      rowItemResult[key] = rowItem[key];
    });
    return rowItemResult;
  });
  doc.autoTable(
    columns.map((item) => ({ ...item, title: "oll" })),
    listRow,
    {
      styles: {
        fillColor: "blue",
        lineColor: 240,
        lineWidth: 1,
      },
      columnStyles: {
        col1: { fillColor: false },
        col2: { fillColor: false },
        col3: { fillColor: false },
        col4: { fillColor: false },
        col5: { fillColor: false },
        col6: { fillColor: false },
      },
      margin: { top: 60 },
      addPageContent: function (data) {
        doc.text("", 40, 30);
      },
    }
  );
};

export function roundToOneDecimal(number) {
  return Math.round(number * 10) / 10;
}
export const getIconByFileType = (name, fontSize = 18) => {
  if (isImage(name))
    return (
      <FileImageOutlined
        style={{
          fontSize,
        }}
        className="first-icon"
      />
    );
  const splitArray = name.split(".");
  const fileType = splitArray[splitArray.length - 1];

  switch (fileType) {
    case "zip":
    case "rar":
      return (
        <FileZipOutlined
          style={{
            fontSize,
          }}
          className="first-icon"
        />
      );
    case "xlsx":
    case "xlsm":
    case "xls":
    case "xml":
      return (
        <FileExcelOutlined
          style={{
            fontSize,
          }}
          className="first-icon"
        />
      );
    case "txt":
    case "csv":
      return (
        <FileTextOutlined
          style={{
            fontSize,
          }}
          className="first-icon"
        />
      );
    case "pdf":
      return (
        <FilePdfOutlined
          style={{
            fontSize,
          }}
          className="first-icon"
        />
      );
    case "docx":
    case "doc":
      return (
        <FileWordOutlined
          style={{
            fontSize,
          }}
          className="first-icon"
        />
      );
    default:
      return (
        <FileOutlined
          style={{
            fontSize,
          }}
          className="first-icon"
        />
      );
  }
};

export function DebounceSelect({
  fetchOptions,
  debounceTimeout = 400,
  forceFetch,
  defaultOptions,
  initLoad,
  setInitLoad,
  ...props
}) {
  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState(defaultOptions);
  const [isFirstTime, setIsFirstTime] = useState(true);
  const fetchRef = useRef(0);
  const loadOptions = (value) => {
    fetchRef.current += 1;
    const fetchId = fetchRef.current;
    setOptions([]);
    setFetching(true);
    setIsFirstTime(false);
    fetchOptions(value).then((newOptions) => {
      if (fetchId !== fetchRef.current) {
        return;
      }
      setOptions(newOptions);
      setFetching(false);
    });
  };

  const debounceFetcher = useMemo(() => {
    return debounce(loadOptions, debounceTimeout);
  }, [fetchOptions, debounceTimeout]);

  useEffect(() => {
    setOptions(defaultOptions);
  }, [defaultOptions]);

  return (
    <Select
      onBlur={() => setOptions([])}
      showSearch
      labelInValue
      filterOption={false}
      onClick={() => isFirstTime && debounceFetcher("")}
      onSearch={debounceFetcher}
      onFocus={() => debounceFetcher("")}
      notFoundContent={fetching ? <LoadingOutlined size="small" /> : null}
      {...props}
      options={options}
    />
  );
}

export const isEmptyData = (data) => {
  if (typeof data === "string") {
    return data.trim() === "";
  }
  return data === undefined || data === null;
};
export function filterEmptyDataSource(dataSource) {
  return !Object.values({ ...dataSource, key: null, id: null }).every((value) =>
    typeof value === "string" ? value.trim() === "" : !value || isEmpty(value)
  );
}
export function formatNumber(input) {
  if (input === null || input === undefined) return "";

  let raw = String(input).replace(/,/g, "").trim();

  if (raw === "" || isNaN(Number(raw))) return "";

  const number = Number(raw);
  return number.toLocaleString("en-US");
}

export function formatNumberFloat(input) {
  if(input === "-") return "-"
  if (input === null || input === undefined) return "";

  let raw = String(input).replace(/,/g, "").trim();

  if (raw === "" || isNaN(Number(raw))) return "";

  const endsWithDot = raw.endsWith(".");

  const [integerPart, decimalPart] = raw.split(".");
  const formattedInteger = Number(integerPart).toLocaleString("en-US");

  if (endsWithDot) {
    return `${formattedInteger}.`;
  }

  return decimalPart !== undefined
    ? `${formattedInteger}.${decimalPart}`
    : formattedInteger;
}

export function formatDecimal(value, decimals = 3) {
  if (value === null || value === undefined || value === "") return "";
  let num = parseFloat(value);
  if (isNaN(num)) return "";

  return num.toFixed(decimals);
}
export function formatNumberFloatKeepDecmal(input) {
  if (input === "-") return "-";
  if (input === null || input === undefined) return "";

  let raw = String(input).replace(/,/g, "").trim();

  if (raw === "" || isNaN(Number(raw))) return "";

  const endsWithDot = raw.endsWith(".");

  const [integerPart, decimalPart] = raw.split(".");

  const formattedInteger = Number(integerPart).toLocaleString("en-US");

  if (endsWithDot) {
    return `${formattedInteger}.`;
  }

  return decimalPart !== undefined
    ? `${formattedInteger}.${decimalPart}`
    : formattedInteger;
}


export function convertGoogleDriveLinkToEmbed(originalUrl) {
  if (typeof originalUrl !== 'string') return '';

  const fileRegex = /https:\/\/drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)(?:\/(view|edit|preview))?/;
  const openRegex = /https:\/\/drive\.google\.com\/open\?id=([a-zA-Z0-9_-]+)/;
  const ucRegex = /https:\/\/drive\.google\.com\/uc\?id=([a-zA-Z0-9_-]+)&?/;
  const folderRegex = /https:\/\/drive\.google\.com\/drive\/folders\/([a-zA-Z0-9_-]+)/;

  let match;

  // Match: https://drive.google.com/file/d/FILE_ID/view
  if ((match = originalUrl.match(fileRegex))) {
    const fileId = match[1];
    return `https://drive.google.com/file/d/${fileId}/preview`;
  }

  // Match: https://drive.google.com/open?id=FILE_ID
  if ((match = originalUrl.match(openRegex))) {
    const fileId = match[1];
    return `https://drive.google.com/file/d/${fileId}/preview`;
  }

  // Match: https://drive.google.com/uc?id=FILE_ID&export=download
  if ((match = originalUrl.match(ucRegex))) {
    const fileId = match[1];
    return `https://drive.google.com/file/d/${fileId}/preview`;
  }

  // Match: Folder share link
  if ((match = originalUrl.match(folderRegex))) {
    const folderId = match[1];
    return `https://drive.google.com/embeddedfolderview?id=${folderId}#grid`;
  }

  return '';
}
export function getThumbnailFromEmbedUrl(embedUrl) {
  const match = embedUrl.match(/\/file\/d\/([a-zA-Z0-9_-]+)\/preview/);
  if (!match) return '';
  return `https://drive.google.com/thumbnail?id=${match[1]}`;
}

export const safeGoBack = (history,url) => {
  if (window.history.length > 2) {
    history.goBack();
  } else {
    history.push(url);
  }
};

